import React from 'react';
export function Footer() {
  return <footer className="bg-cosmic-black relative z-10 py-6 px-6 border-t border-white/5" data-id="element-93">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-94"></div>
    </footer>;
}